module.exports = {"321271400":"泰州经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321271.json
// module id = 1031
// module chunks = 0